import React from 'react';
import '../../StylesCSS/ButtonsLayout.css';
import { ImportExport, Build, Edit, Description, ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const actionRoutes = {
  importResults: 'ImportFileExcelV2',
  minutes: 'PageLayout3V2',
  prepareData: 'PageLayout2V2',
  decision: 'StudentSelectorV2',
};

const PageLayoutActions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { branch, branchLabel } = location.state || {};

  const handleAction = (actionKey) => {
    navigate(`/${actionRoutes[actionKey]}`, {
      state: {
        branch,
        branchLabel,
        action: actionKey,
      },
    });
  };

  const handleBack = () => {
    navigate('/PageLayoutVersion2', {
      state: {
        branch,
        branchLabel,
      },
    });
  };

  const buttonStyle = {
    backgroundColor: '#218C91',
    color: 'white',
    padding: '10px 20px',
    margin: '10px 0',
    borderRadius: '8px',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div>
      <div style={{ marginTop: '60px', marginBottom: '20px' }} />
      <div style={{ maxWidth: '700px', margin: 'auto', textAlign: 'right' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#00B9B9',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
            direction: 'rtl',
            fontFamily: 'Arial, sans-serif',
            fontSize: '22px',
            fontWeight: 'bold',
            height: '80px',
            gap: '20px',
          }}
        >
          <div style={{ width: '16px', height: '16px', backgroundColor: '#FF9900', borderRadius: '2px' }} />
          <span>تدبير مجالس الأقســــام للجدع المشترك</span>
          <div style={{ width: '16px', height: '16px', backgroundColor: '#FF9900', borderRadius: '2px' }} />
        </div>

        <div
          style={{
            marginTop: '18px',
            padding: '10px 14px',
            borderRadius: '8px',
            backgroundColor: '#fff1f2',
            border: '1px solid #fca5a5',
            color: '#b91c1c',
            fontWeight: 'bold',
            textAlign: 'right',
            direction: 'rtl',
            fontSize: '16px',
          }}
        >
          تم اختيار نوع الجدع: <span style={{ color: '#991b1b' }}>{branchLabel}</span>
        </div>

        <h2 className="page-layout-actions-title" dir="rtl">
          <span className="page-layout-actions-title-prefix">تدبير مجالس الأقســــام :</span>{' '}
          <span className="page-layout-actions-title-branch" style={{ color: '#d62828', fontWeight: 'bold' }}>{branchLabel}</span>
        </h2>

        <div className="buttons-container">
          <div className="button-group">
            <button className="btn btn-left" onClick={() => handleAction('importResults')} style={buttonStyle}>
              <ImportExport style={{ marginRight: '8px' }} />
              استيراد النتائج
            </button>
            <button className="btn btn-left" onClick={() => handleAction('minutes')} style={buttonStyle}>
              <Description style={{ marginRight: '8px', fontSize: '24px' }} />
              محاضر التوجيه
            </button>
          </div>
          <div className="button-group">
            <button className="btn btn-right" onClick={() => handleAction('prepareData')} style={buttonStyle}>
              <Build style={{ marginRight: '8px' }} />
              تهيئة المعطيات
            </button>
            <button className="btn btn-right" onClick={() => handleAction('decision')} style={buttonStyle}>
              <Edit style={{ marginRight: '8px' }} />
              مسك القرار
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <button
            className="btn back-action"
            onClick={handleBack}
            style={{ ...buttonStyle, backgroundColor: '#d62828' }}
          >
            <ArrowBack style={{ marginRight: '8px' }} />
            رجوع
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageLayoutActions;
